import React from 'react';
import { Field } from 'react-final-form';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  formControl: {
    marginTop: '1.5rem',
    marginBottom: '1.5rem',
    width: '100%',
  },
  radioGroup: {
    marginTop: '0.5rem',
  },
  formControlLabel: {
    flexGrow: '2',
  },
}));

const InputJointAccount = () => {
  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <Field name="account_type" type="radio" validate={(value) => !value}>
        {({ input, meta }) => (
          <FormControl
            {...input}
            className={classes.formControl}
            error={meta.touched && meta.error}
          >
            <FormLabel>Choose the type of your account</FormLabel>
            <RadioGroup
              aria-label="account_type"
              name="account_type"
              className={classes.radioGroup}
            >
              <FormControlLabel
                className={classes.formControlLabel}
                value="single"
                control={<Radio color="primary" />}
                label="Single account"
              />
              <FormControlLabel
                className={classes.formControlLabel}
                value="joint"
                control={<Radio color="primary" />}
                label="Joint account"
              />
              <FormControlLabel
                className={classes.formControlLabel}
                value="business"
                control={<Radio color="primary" />}
                label="Business account"
              />
            </RadioGroup>
            {meta.touched && meta.error && (
              <FormHelperText>Required</FormHelperText>
            )}
          </FormControl>
        )}
      </Field>
    </Grid>
  );
};

export default InputJointAccount;
